import React, { useMemo } from 'react';
import styles from './index.module.scss';
import { OptionPosition, SelectPickerProps } from './interfaces';
import cx from 'classnames';
import Typography from '@primitives/Typography';
import SelectPickerItem from './SelectPickerItem';

const SelectPicker: React.FC<SelectPickerProps> = ({
  options = [],
  onSelectionChange,
  selectedValue,
  multiSelect = false,
  wrapperClasses,
  noOptionsMessage = 'No options',
  showSourceAtBottom = false,
  optionPosition = OptionPosition.bottom,
  customOptionTemplate,
  selectPickerItemClass,
  ...restProps
}) => {
  const renderOptions = useMemo(() => {
    if (options.length === 0) {
      return (
        <div className={styles['selectPicker--noItemMsg']}>
          <Typography variant="p3">{noOptionsMessage}</Typography>
        </div>
      );
    }
    return options.map(option => (
      <SelectPickerItem
        key={`select-picker-item-${option.value}`}
        selected={selectedValue.has(option.value)}
        optionInfo={option}
        onOptionClick={onSelectionChange}
        multiSelect={multiSelect}
        showSourceAtBottom={showSourceAtBottom}
        customOptionTemplate={customOptionTemplate}
        selectPickerItemClass={selectPickerItemClass}
      />
    ));
  }, [options, selectedValue, showSourceAtBottom]);

  const getStyles = () => {
    return cx(
      styles['selectPicker'],
      wrapperClasses,
      styles[optionPosition === OptionPosition.top ? 'top' : 'bottom']
    );
  };

  return (
    <div className={getStyles()} {...restProps}>
      {renderOptions}
    </div>
  );
};

export default SelectPicker;
